<template>
	<div class="fuwu">
		<header-view></header-view>
		<div class="top">Flority Privacy Policy</div>
		<div class="content">Last updated October 31, 2026</div>
		<div class="title">1. Who is responsible</div>
		<div class="content">HEARD (HK) LIMITED operates FLORITY and is responsible for the processing described here.
			Contact jm@heard.ly for privacy questions or requests. This policy covers the FLORITY app and its local
			browser preview.</div>
		<div class="title">2. Arrangements and messages</div>
		<div class="content">Your flower choices, layout, vase, background, draft, saved Gallery works and preferences
			are stored on your device or in your browser. Recipient names, sender names and notes are used locally to
			create the image you request. We do not upload these works or message fields to a FLORITY server. No account
			is required.</div>
		<div class="title">3. Photos and sharing</div>
		<div class="content">When you choose Save Image, iOS may ask for Photos access to save the generated image. You
			can decline or change access in iOS Settings; arranging flowers does not require Photos access. FLORITY does
			not scan or upload your existing photo library.<br><br>Exported images contain the names and note you
			entered. When you choose to share or open another service, that service receives what you send and processes
			it under its own policy. Copies you save to Photos or share elsewhere are outside FLORITY’s local
			Gallery.</div>
		<div class="title">4. Retention and deletion</div>
		<div class="content">Local drafts, Gallery works and preferences remain until the app or its local data is
			removed. Removing the iOS app or clearing the browser’s FLORITY site data removes its local store; export
			works first. Delete saved Photos images separately in Photos.<br><br>If you email us, we use the email and
			what you send to answer your request, retaining it only as needed for support and applicable legal
			obligations. Runtime diagnostics follow the provider’s service-necessary retention policy. We do not have a
			server copy from which to recover your local artwork.</div>
		<div class="title">5. Your choices and rights</div>
		<div class="content">You can skip message fields, decline Photos access and choose whether to share. Depending
			on your location, you may have rights to access, correct, delete or receive your personal data, object to or
			restrict processing, withdraw consent, and complain to a data-protection authority. Email jm@heard.ly; we
			will verify requests proportionately and respond within applicable legal deadlines. Exercising these rights
			will not result in discriminatory treatment.</div>
		<div class="title">6. Children, security and changes</div>
		<div class="content">FLORITY is not directed to children under 14, and we do not knowingly collect their
			personal information. Contact us if you believe a child has sent us personal information.<br><br>We use
			reasonable safeguards and limit processing to the purposes described here, but no system is completely
			secure. We update this policy when practices change, show the updated date and provide any notice or consent
			required by law.</div>
		<div class="title">Useful links</div>
		<div class="content">
			<li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener">Apple Privacy
					Policy</a></li>
		</div>
		<div class="title">Contact</div>
		<div class="content">HEARD (HK) LIMITED<br>jm@heard.ly</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.fuwu {
		padding: 87px 15px 40px;

		.top {
			font-size: 28px;
			font-weight: 600;
			padding: 25px 0;
		}

		.title {
			font-size: 20px;
			margin: 20px 0;
		}

		.content {
			font-size: 13px;

			li {
				margin: 10px 0;
			}

			a {
				color: inherit;
				text-decoration: underline;
			}
		}
	}
</style>
